module.exports = __webpack_public_path__ + "img/client-4.jpg?78bd5112000126d33204146555e1bb52";